var _a;
export * from "./helpers";
import { UrlFormatter } from "./UrlFormatter";
export const urlFormatter = new UrlFormatter((_a = window.locale) !== null && _a !== void 0 ? _a : navigator.language);
//# sourceMappingURL=index.js.map